import {TSMap} from "typescript-map";
import {PortfolioTableState} from "core/redux/portfolio/PortfolioReduxState";
import Utils from "platform/util/Utils";
import {TradeColumn} from "enum/TradeColumn";
import {SortDirection} from "platform/enum/SortDirection";

enum PortfolioType {

    OpenTrades = "openTrades",
    EntryOrders = "entryOrders",
    ClosedTrades = "closedTrades",
    ActivityLog = "activityLog",
}

namespace PortfolioType {

    export function deserialize(json: string): TSMap<PortfolioType, PortfolioTableState> {
        const tables: TSMap<PortfolioType, PortfolioTableState> = PortfolioType.base();
        if (!Utils.isObjectEmpty(json)) {
            try {
                const portfolioSort: object = JSON.parse(json);
                Object.keys(portfolioSort).forEach((portfolioType: PortfolioType) => {
                    const table: any = portfolioSort[portfolioType];
                    const tableSort: PortfolioTableState = {
                        activeColumn: table.activeColumn,
                        sort: new TSMap<TradeColumn, SortDirection>()
                    };
                    Object.keys(table.sort).forEach((column: TradeColumn) => {
                        tableSort.sort.set(column, table.sort[column]);
                    });
                    tables.set(portfolioType, tableSort);
                });
            } catch (e) {
            }
        }
        return tables;
    }

    export function base(): TSMap<PortfolioType, PortfolioTableState> {
        const tables: TSMap<PortfolioType, PortfolioTableState> = new TSMap();
        tables.set(PortfolioType.OpenTrades, {
            activeColumn: TradeColumn.Symbol,
            sort: new TSMap<TradeColumn, SortDirection>([
                [TradeColumn.Symbol, SortDirection.Ask]
            ])
        });
        tables.set(PortfolioType.EntryOrders, {
            activeColumn: TradeColumn.Symbol,
            sort: new TSMap<TradeColumn, SortDirection>([
                [TradeColumn.Symbol, SortDirection.Ask]
            ])
        });
        tables.set(PortfolioType.ClosedTrades, {
            activeColumn: TradeColumn.Symbol,
            sort: new TSMap<TradeColumn, SortDirection>([
                [TradeColumn.Symbol, SortDirection.Ask]
            ])
        });
        tables.set(PortfolioType.ActivityLog, {
            activeColumn: TradeColumn.Time,
            sort: new TSMap<TradeColumn, SortDirection>([
                [TradeColumn.Time, SortDirection.Ask]
            ])
        });
        return tables;
    }
}

export {PortfolioType};
